export default "__VITE_ASSET__CgWq9w1g__"